import React, {Component} from 'react'
import {Link} from "react-router-dom";

export default class SwaggerApi extends Component {
    renderButton () {
        const { apiId } = this.props;
        return (
                <Link to={"/apis/"+apiId}>Swagger API</Link>

        );
    }
    render() {
        return this.renderButton();
    }
}


/** WEBPACK FOOTER **
 ** ./src/pages/GettingStarted/SwaggerApi.js
 **/